import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton'
import { CircularProgress, useTheme } from '@mui/material'

interface CustomLoadingButtonProps extends LoadingButtonProps {
  outlined?: boolean;
}

const LoginButton = (props: CustomLoadingButtonProps) => {
  const theme = useTheme()
  const { outlined, ...rest } = props

  return (
    <LoadingButton
      {...rest}
      variant={props.variant || 'contained'}
      fullWidth
      loadingIndicator={
        <CircularProgress
          sx={{
            color: theme.palette.grey[100]
          }}
          size={30}
        />
      }
      sx={{
        width: '100%',
        height: '48px',
        background: outlined 
          ? 'transparent !important'
          : props.loading
            ? theme.palette.primary.main
            : props.disabled
              ? theme.palette.grey[200]
              : theme.palette.primary.main,
        border: outlined ? `1px solid ${theme.palette.border.primary}` : 'none',
        color: outlined 
          ? theme.palette.grey[400] 
          : props.disabled 
            ? 'inherit'
            : 'white',
        fontSize: '14px',
        fontWeight: 500,
        borderRadius: '12px',
        '&.Mui-disabled': {
          background: props.loading ? theme.palette.primary.main : theme.palette.grey[200]
        },
        '&:hover': {
          background: outlined ? 'transparent !important' : undefined,
        },
        ...props.sx,
      }}
    />
  )
}

export default LoginButton
